import { gql } from "@apollo/client";

export const QueryGroupUserRoles = gql`
  mutation QueryGroupUserRoles($groupUserRolesQuery: groupUserRolesQuery!) {
    QueryGroupUserRoles(groupUserRolesQuery: $groupUserRolesQuery)
  }
`;

